export class ConfigReader {
  /**
   * decided
   * @returns
   */
  public static getApiDomain() {
    switch (window.location.hostname) {
      case 'staging.skin-seoul.com':
        return 'https://staging-api.skin-seoul.com';
      case 'localhost':
        return 'https://dev-api.skin-seoul.com';
      case 'dev.skin-seoul.com':
        return 'https://dev-api.skin-seoul.com';
      case 'skin-seoul.com':
      default:
        return 'https://api.skin-seoul.com';
    }
  }

  /**
   * decided
   * @returns
   */
  public static getFrontendOrigin() {
    switch (window.location.hostname) {
      case 'staging.skin-seoul.com':
        return 'https://staging.skin-seoul.com';
      case 'localhost':
        return 'https://dev.skin-seoul.com';
      case 'dev.skin-seoul.com':
        return 'https://dev.skin-seoul.com';
      case 'skin-seoul.com':
      default:
        return 'https://skin-seoul.com';
    }
  }
}
